import * as apiHelper from '../../apiHelper';
import * as constants from "./constants";
import * as a_constants from "../dashboard/constants";
import * as qs from 'query-string';

import { PAGE_ROUTES } from '../../constants/pageRoutes';

import { getUserInfo } from '../dashboard/actions';

export const getSearchQuery = () => {
  let query = {};
  if (location.search) {
    query = qs.parse(location.search, { ignoreQueryPrefix: true });
  } else if (location.hash.indexOf('?') > -1) {
    query = qs.parse(location.hash.substr(location.hash.indexOf('?')), { ignoreQueryPrefix: true });
  }

  return query;
}

export const getPageLocationLink = () => {
  return window.location.hash.substr(1);
}

export const getQueryRedirectLink = () => {

  const query = getSearchQuery();

  if (query.redirect) {
    //Assume redirect is always the first & only query param
    return location.hash.substr(location.hash.indexOf('=') + 1);
  }
  return null;
}

export const getQuerySuccessRedirectLink = () => {

  const query = getSearchQuery();
  if (query.successRedirect) {
    //Assume redirect is always the first & only query param
    return location.hash.substr(location.hash.indexOf('=') + 1);
  }
  return null;
}

const onLoginComplete = (dispatch, json) => {
  if (json.error) {
    dispatch(pushError(json.error));
    return;
  }

  dispatch(setUserLoggedIn(json.user._id, json.token));
  dispatch(setUserData(json.user));

  const redirectLink = getQueryRedirectLink();
  dispatch(navigateTo(redirectLink ? redirectLink : PAGE_ROUTES.DASHBOARD));
}

export function login(data) {
  return (dispatch) => {
    dispatch(popError('login'));
    return apiHelper.apiPost('login', data)
      .then(response => response.json())
      .then(json => {
        onLoginComplete(dispatch, json);
      }).catch(e => {
        console.log(e);
        dispatch(pushError({ errType: 'login', message: "A Server Error Occurred." }))
      })
  }
}

export function checkAuthorization() {
  return (dispatch, getState) => {
    let state = getState();
    let global = state.Global;
    return apiHelper.apiGet('auth', global.token)
      .then(response => response.status >= 400 ? { auth: false } : response.json())
      .then(json => {
        if (json.auth === false) {
          dispatch(setUserLoggedOut());
          dispatch(pushError({ errType: 'login', message: "You were logged out due to inactivity." }));
        }
        else {
          dispatch(setUserLoggedIn(global.userId, global.token));
          if (!state.Dashboard.user) {
            dispatch(getUserInfo(global.userId));
          }
        }
      })
  }
}

export function setUserData(userData) {
  return {
    type: a_constants.SET_USER_DATA,
    data: userData
  }
}


export function setUserLoggedIn(userId, token) {
  return {
    type: constants.LOGIN,
    data: { userId: userId, token: token }
  }
}

export function setUserLoggedOut() {
  return {
    type: constants.LOGOUT
  }
}

export function pushSuccess(success) {
  if (!success.successType) {
    success = {
      errType: "generic",
      message: success
    }
  }
  return {
    type: constants.PUSH_SUCCESS,
    data: success
  }
}

export function pushError(err) {
  if (!err.errType) {
    err = {
      errType: "generic",
      message: err
    }
  }
  return {
    type: constants.PUSH_ERROR,
    data: err
  }
}

export function popError(errType) {
  return {
    type: constants.POP_ERROR,
    data: errType
  }
}

export function popSuccess(errType) {
  return {
    type: constants.POP_SUCCESS,
    data: errType
  }
}

export function navigateTo(location) {
  return {
    type: constants.NAVIGATE_TO_PAGE,
    data: location
  }
}

